import { render } from "./Key.vue?vue&type=template&id=bb1c29a6"
import script from "./Key.vue?vue&type=script&lang=js"
export * from "./Key.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bb1c29a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb1c29a6', script)) {
    api.reload('bb1c29a6', script)
  }
  
  module.hot.accept("./Key.vue?vue&type=template&id=bb1c29a6", () => {
    api.rerender('bb1c29a6', render)
  })

}

script.__file = "src/icons/components/filled/Key.vue"

export default script